export default class DeviseUser {

    constructor(isReset) {
        $.validator.addMethod("alphanumeric_no_white", function(value, element) {
            return this.optional(element) || /^([\p{L}0-9_\-]{4,127}$)/u.test(value);
        },
            I18n.t("admins.registrations.new.username_invalid")
        );
        $.validator.addMethod(
            "uniqueUserName",
            function(value, element) {
                let response = $.ajax({
                    type: "GET",
                    url: window.application.getAPIUrl()+"/v1/users/check_user_name",
                    data: {username: value},
                    async: false,
                    beforeSend: function (request) {
                        request.setRequestHeader("X-STL-Token", cookies.get("STL-Token"));
                    }
                });

                return response.responseJSON.exists !== true
            },
            I18n.t("admins.registrations.new.username_taken")
        );
        $.validator.addMethod(
            "uniqueEmail",
            function(value, element, params) {
                let response = $.ajax({
                    type: "GET",
                    url: window.application.getAPIUrl()+"/v1/users/check_email",
                    data: {email: value},
                    async: false,
                    beforeSend: function (request) {
                        request.setRequestHeader("X-STL-Token", cookies.get("STL-Token"));
                    }
                });

                return response.responseJSON.exists !== true
            },
            function(params, element) {
                return I18n.t("admins.registrations.new.email_taken", {email: $(element).val()});
            }
        );
        if(isReset){
            this.validation_options = {
                rules:{
                    "user[email]": {
                        required: true
                    }
                }
            }
        }else{
            this.validation_options = {
                rules:{
                    "user[email]": {
                        required: true,
                        uniqueEmail: true
                    },
                    "user[user_name]": {
                        required: true,
                        minlength: 4,
                        alphanumeric_no_white: true,
                        uniqueUserName: true
                    },
                    "user[password]": {
                        minlength: 8,
                        required: true
                    },
                    "user[password_confirmation]": {
                        required: true,
                        equalTo: "#user_password"
                    }
                }
            }
        }

        if(I18n.locale !== 'en'){
            this.validation_options.messages = require("jquery-validation/dist/localization/messages_"+I18n.locale)
        }
        this.validation = $("form").validate(this.validation_options)
        this.bindEvents();
        //window.application.setOnDataChangeListener(this);
    }


    bindEvents() {
    }

    onDataChanged(data) {
    }

    onDestroy() {
        this.validation.destroy();
    }

}